import NextContext from "@client/context/next";
import * as React from "react";
import { getModuleInfo } from "../dataProvider";

export default (moduleType: string, id: string) => {
  const nextContext = React.useContext(NextContext);

  const mi = getModuleInfo(moduleType);

  React.useLayoutEffect(() => {
    if (!mi.data?.getReducer) return;

    const reducer = mi.data.getReducer(id);

    nextContext.injectReducer(`modules.${id}`, reducer);

    return () => {
      // if (reducer) {
      // TODO_NEXT3: when moving an entity up, it will mount to the new place, and only then unmount from the old place. This breaks the reducers
      // also, we only need to unmount page content entity reducers on page load
      // nextContext.removeReducer(`modules.${props.id}`);
      // }
    };
  }, [id]);
};
